import TitleUpdater from '../../../../../utils/TitleUpdater';
import ERPImpact from './ERPImpact';
import ERPConsultingHighlights from './ERPConsultingHighlights';
import ERPPlatforms from './ERPPlatforms';
import Intro from './Intro';
import ServicesOverview from './ServicesOverview';
import IndustriesWeServe from './IndustriesWeServe';
import EnterpriseSoftwareFaqs from './EnterpriseSoftwareFaqs';

export default function EnterpriseSoftwareConsulting() {
  return (
    <main className="font-['Be_Vietnam_Pro']" style={{ background: '#F5F2EE', color: '#171717', overflow: 'hidden' }}>
      <TitleUpdater title="Enterprise Software Consulting" />
      <Intro />
      <ERPImpact />
      <ServicesOverview />
      <ERPConsultingHighlights />
      <ERPPlatforms />
      <IndustriesWeServe />
      <EnterpriseSoftwareFaqs />
    </main>
  );
}
